import { add, cart, change, clear, update } from './cart';
import { product } from './product';

const shopifyClient = {
  add,
  cart,
  change,
  clear,
  update,
  remove: (id) => change({ id: `${id}`, quantity: '0' }),
  product,
};

export default shopifyClient;
